module.exports = __webpack_public_path__ + "static/img/精雕瓷碗.188239a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/设计市场/精雕瓷碗.jpg
// module id = XUYE
// module chunks = 1